module.exports = __webpack_public_path__ + "img/9788952777072.5fae147d.jpg";